import {ACTION} from './constants';
import request from '../../../../utils/request';
import {requestConfig} from "../../../../config/apiResource";
import {formDataGenerator} from "../../../../utils/common";


export function SurveyUser(serverData,data) {
    let surveyData;
    if (serverData.url) {
        let urlArray = serverData.url.split("/"),
        uniqueId = urlArray[urlArray.length - 1],
        userType = urlArray[urlArray.length - 2],
        typeData;

        if(userType == "investors-ft-survey"){
            typeData = 'ft';
        } else if(userType == "investors-nft-survey"){
            typeData = 'nft';
        } else if(userType == "partners-survey"){
            typeData = 'partner';
        }

        let data = {
            userId: uniqueId,
            surveyType: typeData,
        };
        surveyData = formDataGenerator(data);
    } else {
        surveyData = data;
    }
    return dispatch => {
        return request(requestConfig.SurveyUser(surveyData))
            .then((json) => {
                json && dispatch({ type: ACTION.SURVEY_USER , data: json.data });
                return json;
            }).catch((error) => {
                console.log("Got Error with SURVEY Users: " + error)
            });
    }
};